import { createSelector } from "reselect";
import userConstants from "../../_constants/userConstants";
//EXTRACT THE PART OF THE STATE
const getData = state => state.user.profile;
//VERIFY IF THE JWT IS SET
const getProfilePicture = createSelector(
  getData,
  profile =>
    profile.imageURL
      ? profile.imageURL
      : profile.isFemale
        ? userConstants.FEMALE_IMAGE
        : userConstants.MALE_IMAGE
);
export default getProfilePicture;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getProfilePicture.js